<div class="item-grid-container">
  <div class="retailer-details-grid search-holder">
    <ul class="list-inline grid-top-actions mb-3">
      <li class="list-inline-item ">
        <input
          type="text"
          placeholder="{{ 'pages.newRetailer.search' | translate }}"
          matInput
          class="
            rounded-pill
            px-3
            py-2
            mb-0
            border-0
            bg-light
            w-100
            me-0
            input-search
            ms-3
          "
          (keyup)="quickSearch()"
          [(ngModel)]="searchValue"
        />
        <i
          color="primary"
          class="search-icon-holder"
          matSuffix
          mat-icon-button
          aria-label="Search"
        >
          <mat-icon>search</mat-icon>
        </i>
      </li>

      <li class="list-inline-item float-end mx-2">
        <button
          mat-stroked-button
          [disabled]="!showDeleteRetailer"
          class="bg-theme"
          (click)="onCloseRetailer(selectedRetailerInfo)"
        >
          <i class="mi mi-person-remove me-2"></i
          ><span translate class="translate">{{ 'pages.newRetailer.close' | translate }}</span>
        </button>
      </li>
    </ul>
    <ag-grid-angular
      style="width: 100%; height: 65vh"
      class="ag-theme-material"
      #agGrid
      id="myGrid"
      [rowHeight]="40"
      [rowSelection]="'single'"
      [rowData]="retailerDetails"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      [floatingFilter]="false"
      [paginationPageSize]="10"
      [pagination]="true"
    >
    </ag-grid-angular>
  </div>
</div>
